import { useTheme } from 'styled-components'

import { useMediaQuery } from '@mui/material'

export const useScreenDimensions = () => {
  const theme = useTheme()
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))
  const isLgDesktop = useMediaQuery(theme.breakpoints.up('lg'))

  const isLandscapeTablet = useMediaQuery('(min-width: 768px) and (max-width: 1200px) and (orientation: landscape)')

  const isDesktopWidth = useMediaQuery(theme.breakpoints.up('md'))

  const isDesktop = isDesktopWidth && !isLandscapeTablet

  return { isMobile, isTablet, isDesktop, isLgDesktop, isSmallMobile }
}
